import React from 'react';
import { createPortal } from 'react-dom';
import { Button, FormInput, Modal } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

export const DuplicateSharedListModal = ({ list, isLoading, onCloseModal, onDuplicateSharedList }) => (
  <div
    role="presentation"
    data-testid="duplicate-list-modal"
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
  >
    {createPortal(
      <Modal
        title="Duplicate list"
        isOpen
        onCancel={onCloseModal}
        actions={
          <Flex sx={{ gap: '8px', justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={onCloseModal}>
              Cancel
            </Button>
            <Button
              data-testid="duplicate-btn"
              variant="primary"
              type="submit"
              form="duplicate-list-form"
              loading={isLoading}
            >
              Duplicate list
            </Button>
          </Flex>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            This will create a new list with the same contacts and settings.
          </p>
          <Formik
            initialValues={{ name: `Copy of ${list.name}` }}
            validationSchema={Yup.object().shape({ name: Yup.string().required('Name is required') })}
            onSubmit={(values) => onDuplicateSharedList(list, values.name)}
          >
            <Form id="duplicate-list-form">
              <Field component={FormInput} name="name" autoFocus label="New list name" />
            </Form>
          </Formik>
        </div>
      </Modal>,
      document.getElementById('portals'),
    )}
  </div>
);

DuplicateSharedListModal.propTypes = {
  list: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDuplicateSharedList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

DuplicateSharedListModal.defaultProps = {
  isLoading: false,
};
